import { LogOut } from "lucide-react"
import { useEffect } from "react"
import { useAuth } from "@/auth/AuthProvider"
import { VerwaltungPage } from "@/pages/admin/VerwaltungPage"

const UMGEBUNG = (import.meta.env.VITE_ENV as string | undefined) ?? "dev"

/** Verwaltung des Betriebstagebuchs (btb.rmnc.app/verwaltung) — getrennt von ProDash. */
export function VerwaltungRahmen() {
  const { user, signOut } = useAuth()
  useEffect(() => {
    document.title = "Betriebstagebuch – Verwaltung"
  }, [])
  return (
    <div className="min-h-screen">
      <header className="border-b border-hair/10 bg-surface">
        <div className="mx-auto flex max-w-[1260px] flex-wrap items-center gap-x-5 gap-y-2 px-4 py-2.5">
          <div className="flex items-center gap-2">
            <img src={`${import.meta.env.BASE_URL}favicon.svg`} alt="" className="h-6 w-6" />
            <span className="font-semibold">Betriebstagebuch</span>
            <span className="text-[13px] text-ink2">Verwaltung</span>
            {UMGEBUNG !== "prod" && (
              <span className="rounded bg-warn/30 px-1.5 py-0.5 font-mono text-[10.5px] uppercase tracking-wider text-ink">{UMGEBUNG}</span>
            )}
          </div>
          <div className="ml-auto flex items-center gap-3 text-[12.5px] text-ink2">
            <span>{user?.name}</span>
            <button type="button" onClick={signOut} className="inline-flex items-center gap-1 hover:text-ink" title="Abmelden">
              <LogOut className="h-4 w-4" aria-hidden="true" /> Abmelden
            </button>
          </div>
        </div>
      </header>
      <VerwaltungPage />
    </div>
  )
}
